/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, createContext, useState, ReactChild, useContext, useEffect } from 'react';
import { FeedModel } from '../models/models';
interface FeedContext {
  feed?: any;
  setFeed?: any;
}

const context = createContext<FeedContext>({});

const { Provider } = context;

interface Props {
  children: ReactChild | ReactChild[];
}

export const FeedProvider: FC<Props> = ({ children }) => {
  const [feed, setFeed] = useState<FeedModel>();

  useEffect(() => {
    //
  }, []);

  return (
    <Provider
      value={{
        feed,
        setFeed
      }}>
      {children}
    </Provider>
  );
};

export const useFeed = () => useContext(context);
